"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readPagePropertyFrame = readPagePropertyFrame;
const OrcadDsnCfbStreamUtils_1 = require("./OrcadDsnCfbStreamUtils");
function readPagePropertyFrame(payload, kind, report) {
    const candidates = [];
    for (let offset = 0; offset + 12 <= payload.length; offset++) {
        if (payload[offset] !== kind || payload[offset + 9] !== kind) {
            continue;
        }
        const count = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt16LE(payload, offset + 10);
        const length = OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(payload, offset + 1);
        if (offset + length + 1 === payload.length && length !== 11 + count * 8) {
            report(`property-frame-count-mismatch offset=${offset} kind=${kind} length=${length} count=${count}`);
        }
        if (length !== 11 + count * 8 || offset + length + 1 !== payload.length) {
            continue;
        }
        const pairs = [];
        for (let index = 0; index < count; index++) {
            pairs.push({
                nameId: OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(payload, offset + 12 + index * 8),
                valueId: OrcadDsnCfbStreamUtils_1.OrcadDsnCfbStreamUtils.readUInt32LE(payload, offset + 16 + index * 8),
            });
        }
        candidates.push(pairs);
    }
    if (candidates.length > 1) {
        report(`property-frame-ambiguous kind=${kind} candidates=${candidates.length}`);
    }
    return candidates.length === 1 ? candidates[0] : undefined;
}
//# sourceMappingURL=OrcadDsnCfbPagePropertyFrames.js.map